import * as actionTypes from '../../constants/actionTypes';

const initialState = {
  isLight: true,
  isExpanded: true,
  isLoggedIn: false,
};

export default function(state = initialState, action) {
  switch (action.type) {
    case actionTypes.CHANGE_THEME:
    case actionTypes.EXPAND_COLLAPSE_DRAWER:
      return Object.assign({}, state, action.payload);
    case actionTypes.LOGIN_SUCCESS:
    case actionTypes.LOGOUT_ERROR:
      return Object.assign({}, state, { isLoggedIn: true });
    case actionTypes.LOGIN_ERROR:
    case actionTypes.LOGOUT_SUCCESS:
      return Object.assign({}, state, { isLoggedIn: false });
    default:
      return state;
  }
}
